import $ from 'jquery';

import { Direction } from 'webapp/enums/enums';
import { TourId } from 'webapp/enums/tour';
import { TrackingEvent } from 'webapp/enums/tracking';
import { UserSettingsKey } from 'webapp/enums/user-settings';

import type { StepData } from 'webapp/models-custom/tour';
import TourBase from 'webapp/models-custom/tour';

export default class ClientsSetupTour extends TourBase {
	static keyForPersistantDone = UserSettingsKey.CLIENTS_SETUP;
	override trackEvent: TrackingEvent | '' = TrackingEvent.BUBBLE_CLIENTS_SETUP;

	get id(): string {
		return TourId.CLIENTS_SETUP;
	}

	override get keyForPersistantDone(): string {
		return ClientsSetupTour.keyForPersistantDone;
	}

	override get stepData(): StepData[] {
		return [
			{
				direction: Direction.DOWN,
				attachTo: () => {
					return $('#clients-list table tbody tr .optionsbutton').eq(0);
				},
			},
		];
	}

	override start(): void {
		super.start();
		this.markDone(); // just one step, once seen, it's done
	}
}
